import { render, staticRenderFns } from "./changeCarInfo.vue?vue&type=template&id=5facd2dc"
import script from "./changeCarInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./changeCarInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports